// extracted by mini-css-extract-plugin
export default {"availability":"YZKx_Q","list":"vMglaF","socialList":"nzx3of","item":"jMwBUW","icon":"BaizXo","contactLink":"CwRDxM"};